import AuthorStars from '@assets/icons/AuthorStars';
import parse from 'html-react-parser';
import AuthorImage from '@assets/images/author-block-image-fallback.jpg';
import { useIsMobile } from '@hooks/useIsMobile';
import {
	ArticleTitle,
	ArticleOffer,
	ArticleMeta,
	WrittenBy,
	ArticleMetaText,
	ArticleTop,
} from './articleTopBlock.styled';

interface ArticleTopBlockProps {
	title: string;
	offerLabel: string;
	writtenLabel: string;
	metaText: string;
	authorImage?: string;
	authorName?: string;
	daysAgo?: number;
}

const ArticleTopBlock: React.FC<ArticleTopBlockProps> = ({
	title,
	offerLabel,
	writtenLabel,
	metaText,
	authorImage,
	authorName,
	daysAgo,
}) => {
	const isMobile = useIsMobile();
	return (
		<ArticleTop>
			<ArticleTitle>{title}</ArticleTitle>
			<ArticleOffer>{parse(offerLabel)}</ArticleOffer>
			<ArticleMeta>
				{!isMobile && <AuthorStars />}
				{!isMobile && <WrittenBy>{writtenLabel}</WrittenBy>}
				<img src={authorImage ? authorImage : AuthorImage} alt="Post Author" />
				<ArticleMetaText>
					{isMobile && writtenLabel} {isMobile && <strong>{authorName}</strong>} {!isMobile && authorName}  {isMobile && <br />}
					On <span data-days-ago={daysAgo}></span> {metaText}
				</ArticleMetaText>
			</ArticleMeta>
		</ArticleTop>
	);
};

export default ArticleTopBlock;
